import { IUserLevelInfoSchema } from '../../repositories/offer-card/entities/agent/UserLevelInfoSchema';
import { IState } from '../../store';

export const selectAgentLevelInfo = (state: IState): IUserLevelInfoSchema | undefined | null => {
  return state.offerData.agent?.moderationInfo?.userLevelInfo;
};
